import { useContext } from 'react'
import { ConsentContext } from '../context/parentalConsentContext'

export default function useParentalConsent() {
  const context = useContext(ConsentContext)
  if (context === undefined) {
    throw new Error('useParentalConsent must be used within ConsentContext')
  }
  return context
}
